import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CurrencyMaskModule } from "ng2-currency-mask";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { HomeComponent } from './components/home/home.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { LicensingComponent } from './components/licensing/licensing.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ArticleDetailsComponent } from './components/article-details/article-details.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
//import { NgxMaskModule } from 'ngx-mask';
import { HttpClientModule } from '@angular/common/http';
import { NewAppThankYouComponent } from './components/new-app-thank-you/new-app-thank-you.component';

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HomeComponent,
    ArticlesComponent,
    HeaderComponent,
    FooterComponent,
    PrivacyComponent,
    AccessibilityComponent,
    LicensingComponent,
    PageNotFoundComponent,
    ArticleDetailsComponent,
    CalculatorComponent,
    NewAppThankYouComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    MatProgressBarModule,
    HttpClientModule,
    CurrencyMaskModule
   // NgxMaskModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
